var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#646A82",
    d: "M10,16.3c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2l-5.5-5.5c-0.2-0.2-0.2-0.4-0.2-0.6 c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2l4.1,4.1V4.1c0-0.2,0.1-0.4,0.2-0.6C9.6,3.4,9.8,3.3,10,3.3 c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6v9.3l4.1-4.1c0.2-0.2,0.4-0.2,0.6-0.2s0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6 c0,0.2-0.1,0.4-0.2,0.6l-5.5,5.5c-0.1,0.1-0.2,0.1-0.3,0.2C10.2,16.3,10.1,16.3,10,16.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownward);
export default __webpack_public_path__ + "static/media/ArrowDownward.f7f6a50913b82e3771ea2248b91eb285.svg";
export { ForwardRef as ReactComponent };